import { put, take } from 'redux-saga/effects';

// eslint-disable-next-line import/no-unresolved
import { loadingAction, snackbarAction } from 'redux/settings/action';

import { ActionTypeEnum } from './../ActionTypeEnum';

export default function* errorWatcher() {
	const { payload, type } = yield take(ActionTypeEnum.error);
	yield put(loadingAction(false));

	const errorRes = payload?.message;

	if (type) {
		if (errorRes) {
			yield put(snackbarAction({ message: errorRes, severity: 'error' }));
			// meta?.setErrors?.()
		} else {
			yield put(snackbarAction({ message: 'Web Server Error Messages' || '', severity: 'error' }));
		}
	}
}
